import { translate } from "@utils";

import { ChipWithBadge } from "@shared/components";

import Tooltip from "@mui/material/Tooltip";

export const PolicyLevelsChipList = ({ policy }) => {
	const { levels } = policy;

	return (
		<div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
			{levels.organizations.length ? <TooltipChipWithBadge label={translate("organizations")} level={levels.organizations} /> : <></>}
			{levels.companies.length ? <TooltipChipWithBadge label={translate("companies")} level={levels.companies} /> : <></>}
			{levels.groups.length ? <TooltipChipWithBadge label={translate("groups")} level={levels.groups} /> : <></>}
			{levels.computers.length ? <TooltipChipWithBadge label={translate("devices")} level={levels.computers} /> : <></>}
		</div>
	);
};

const TooltipChipWithBadge = ({ label, level }) => {
	return (
		<>
			<Tooltip
				sx={{ minWidth: "150px" }}
				title={
					<>
						{level.map((entity, index) => {
							if (index === 10) return <div key={`${label}-${entity.name}-${entity.id}`}>...</div>;
							if (index > 10) return <span key={`${label}-${entity.name}-${entity.id}`}></span>;
							return (
								<div key={`${label}-${entity.name}-${entity.id}`}>
									{entity.name} ({entity.id})
								</div>
							);
						})}
					</>
				}
			>
				<span>
					<ChipWithBadge chipProps={{ label, color: "secondary" }} badgeProps={{ badgeContent: level.length, max: 999 }} />
				</span>
			</Tooltip>
		</>
	);
};
